import * as Yup from 'yup';
import moment from 'moment';

function momentToDate(value, originalValue) {
    return originalValue && originalValue.clone().toDate();
}

const BobTimestampFilter = Yup.object().shape({
    endTimestamp: Yup.date()
        .transform(momentToDate)
        .nullable()
        .min(
            Yup.ref('startTimestamp'),
            'End date must be after the start date.'
        ).test({
            name:      'EndDateValidation',
            exclusive: false,
            params:    {},
            message:   'End date must be after the start date.',
            test:      function(value) {
                const startDate = moment(this.parent.startTimestamp);
                const endDate = moment(value);

                // the start time must be at least 1 hour less
                const differenceMinutes = moment(endDate).diff(startDate, 'minutes');

                if (moment(startDate).isSame(moment(endDate))) {
                    return false;
                } else if (differenceMinutes < 60) {
                    return false;
                }

                return true;
            },
        }),
    startTimestamp: Yup.mixed()
        .transform(momentToDate)
        .nullable()
    
});

export default BobTimestampFilter;
